// EXACT MOBILE TEMPLATE IMPLEMENTATION
// Based on mobile-dashboard-clean (1).html

export function createExactMobileDashboard(scene, dashboardData, initials, firmBadges) {
    console.log('📱 Creating EXACT mobile template dashboard...');
    
    // Remove any existing overlay
    scene.removeExistingOverlay();
    
    // Create main overlay
    const overlay = document.createElement('div');
    overlay.id = 'auth-menu-dom-overlay';
    overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
        z-index: 10000;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'SF Pro Display', system-ui, sans-serif;
        color: #ffffff;
        overflow: hidden;
        height: 100vh;
        height: 100dvh;
    `;
    
    // EXACT mobile template HTML
    overlay.innerHTML = `
        <div class="container">
            <!-- Header - EXACT TEMPLATE MATCH -->
            <header class="header">
                <div class="header-content">
                    <button class="btn-hamburger" data-action="menu">
                        <div class="hamburger-icon">
                            <div class="hamburger-line"></div>
                            <div class="hamburger-line"></div>
                            <div class="hamburger-line"></div>
                        </div>
                    </button>
                    
                    <div class="brand-logo">DeckOps.ai</div>
                    
                    <div class="user-avatar">${initials}</div>
                </div>
            </header>

            <!-- Main Content -->
            <div class="main-content">
                <!-- Performance Stats -->
                <div class="stats-section">
                    <h2 class="section-title">Performance Overview</h2>
                    
                    <div class="stats-grid">
                        <div class="stat-card primary">
                            <div class="stat-icon">📊</div>
                            <div class="stat-content">
                                <div class="stat-value">${dashboardData.overallStats.totalScore || 2847}</div>
                                <div class="stat-label">Total Score</div>
                                <div class="stat-change positive">+12% this week</div>
                            </div>
                        </div>
                        
                        <div class="stat-card">
                            <div class="stat-icon">🏆</div>
                            <div class="stat-content">
                                <div class="stat-value">#${dashboardData.overallStats.globalRank || 12}</div>
                                <div class="stat-label">Global Rank</div>
                                <div class="stat-change positive">+3 positions</div>
                            </div>
                        </div>
                        
                        <div class="stat-card">
                            <div class="stat-icon">🎯</div>
                            <div class="stat-content">
                                <div class="stat-value">${Math.round(dashboardData.overallStats.accuracy || 94)}%</div>
                                <div class="stat-label">Accuracy</div>
                                <div class="stat-change positive">+2.3%</div>
                            </div>
                        </div>
                        
                        <div class="stat-card">
                            <div class="stat-icon">⏱️</div>
                            <div class="stat-content">
                                <div class="stat-value">18.5h</div>
                                <div class="stat-label">Training Time</div>
                                <div class="stat-change negative">-1.2h</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Training Modules -->
                <div class="modules-section">
                    <div class="section-header">
                        <h2 class="section-title">Training Modules</h2>
                        <button class="btn-view-all" data-action="view-all">View All</button>
                    </div>
                    
                    <div class="modules-grid">
                        <div class="module-card active" data-game="ppt-hero">
                            <div class="module-header">
                                <div class="module-icon">📈</div>
                                <div class="module-status">Active</div>
                            </div>
                            <h3 class="module-title">PPT Hero</h3>
                            <p class="module-description">Master PowerPoint shortcuts and workflows</p>
                            <div class="module-progress">
                                <div class="progress-bar">
                                    <div class="progress-fill" style="width: 68%"></div>
                                </div>
                                <div class="progress-text">68% Complete</div>
                            </div>
                            <div class="module-stats">
                                <span>Level 5/10</span>
                                <span>Score: ${dashboardData.pptHeroData?.score || 3141}</span>
                            </div>
                        </div>
                        
                        <div class="module-card active" data-game="philosophy-flow">
                            <div class="module-header">
                                <div class="module-icon">🎨</div>
                                <div class="module-status">Active</div>
                            </div>
                            <h3 class="module-title">Philosophy Flow</h3>
                            <p class="module-description">Strategic thinking through emotion and color</p>
                            <div class="module-progress">
                                <div class="progress-bar">
                                    <div class="progress-fill" style="width: 42%"></div>
                                </div>
                                <div class="progress-text">42% Complete</div>
                            </div>
                            <div class="module-stats">
                                <span>Level 3/10</span>
                                <span>Score: 0</span>
                            </div>
                        </div>
                        
                        <div class="module-card coming-soon" data-game="slide-wars">
                            <div class="module-header">
                                <div class="module-icon">⚔️</div>
                                <div class="module-status">Coming Soon</div>
                            </div>
                            <h3 class="module-title">Slide Wars</h3>
                            <p class="module-description">Competitive presentation battles</p>
                            <div class="module-progress">
                                <div class="progress-bar">
                                    <div class="progress-fill" style="width: 0%"></div>
                                </div>
                                <div class="progress-text">Coming Soon</div>
                            </div>
                        </div>
                        
                        <div class="module-card coming-soon" data-game="classify-tech">
                            <div class="module-header">
                                <div class="module-icon">🏛️</div>
                                <div class="module-status">Coming Soon</div>
                            </div>
                            <h3 class="module-title">Classify Tech</h3>
                            <p class="module-description">Technology categorization training</p>
                            <div class="module-progress">
                                <div class="progress-bar">
                                    <div class="progress-fill" style="width: 0%"></div>
                                </div>
                                <div class="progress-text">Coming Soon</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Quick Actions -->
                <!-- REMOVED: Non-template-compliant quick actions section -->
            </div>

            <!-- Navigation Menu Overlay -->
            <div class="nav-overlay" id="nav-overlay">
                <div class="nav-content">
                    <div class="nav-header">
                        <div class="nav-brand">
                            <div class="nav-logo">D</div>
                            <div class="nav-title">DeckOps.ai</div>
                        </div>
                        <button class="btn-close" data-action="close-menu">×</button>
                    </div>
                    
                    <nav class="nav-menu">
                        <div class="nav-section">
                            <div class="nav-section-title">Main</div>
                            <a href="#" class="nav-item active" data-action="dashboard">
                                <span class="nav-icon">🏠</span>
                                <span class="nav-label">Dashboard</span>
                            </a>
                            <a href="#" class="nav-item" data-action="analytics">
                                <span class="nav-icon">📊</span>
                                <span class="nav-label">Analytics</span>
                            </a>
                            <a href="#" class="nav-item" data-action="ppt-hero-analytics">
                                <span class="nav-icon">📈</span>
                                <span class="nav-label">PPT Hero Analytics</span>
                            </a>
                            <a href="#" class="nav-item" data-action="hall-of-fame">
                                <span class="nav-icon">🏆</span>
                                <span class="nav-label">Hall of Fame</span>
                            </a>
                        </div>
                        
                        <div class="nav-section">
                            <div class="nav-section-title">Training</div>
                            <a href="#" class="nav-item" data-game="ppt-hero">
                                <span class="nav-icon">📈</span>
                                <span class="nav-label">PPT Hero</span>
                            </a>
                            <a href="#" class="nav-item" data-game="philosophy-flow">
                                <span class="nav-icon">🎨</span>
                                <span class="nav-label">Philosophy Flow</span>
                            </a>
                        </div>
                        
                        <div class="nav-section">
                            <div class="nav-section-title">Account</div>
                            <a href="#" class="nav-item" data-action="profile">
                                <span class="nav-icon">👤</span>
                                <span class="nav-label">Profile</span>
                            </a>
                            <a href="#" class="nav-item" data-action="notifications">
                                <span class="nav-icon">🔔</span>
                                <span class="nav-label">Notifications</span>
                            </a>
                            <a href="#" class="nav-item" data-action="logout">
                                <span class="nav-icon">🚪</span>
                                <span class="nav-label">Logout</span>
                            </a>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    `;
    
    // Load mobile template CSS
    if (!document.getElementById('mobile-dashboard-exact-css')) {
        const link = document.createElement('link');
        link.id = 'mobile-dashboard-exact-css';
        link.rel = 'stylesheet';
        link.href = '/mobile-dashboard-exact.css?v=' + Date.now();
        document.head.appendChild(link);
    }
    
    document.body.appendChild(overlay);
    
    // Bind mobile events
    setTimeout(() => {
        scene.bindMobileTemplateEvents();
        scene.sceneReady = true;
        console.log('📱 EXACT mobile template dashboard ready');
    }, 100);
    
    return overlay;
}

export function bindMobileTemplateEvents(scene) {
    // Hamburger menu
    const hamburger = document.querySelector('.btn-hamburger');
    const navOverlay = document.getElementById('nav-overlay');
    const closeBtn = document.querySelector('.btn-close');
    
    if (hamburger) {
        hamburger.addEventListener('click', () => {
            navOverlay.classList.add('active');
        });
    }
    
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            navOverlay.classList.remove('active');
        });
    }
    
    // Navigation items
    const navItems = document.querySelectorAll('.nav-item[data-action]');
    navItems.forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            navOverlay.classList.remove('active');
            const action = e.currentTarget.dataset.action;
            scene.handleTemplateAction(action);
        });
    });
    
    // Game items
    const gameItems = document.querySelectorAll('.nav-item[data-game], .module-card[data-game]');
    gameItems.forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            const game = e.currentTarget.dataset.game;
            scene.handleGameAction(game);
        });
    });
    
    // Action cards
    // REMOVED: Action card events (non-compliant quick actions removed)
    
    console.log('📱 Mobile template events bound successfully');
}
